import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Activity } from "lucide-react";

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get("/audit/me").then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, []);

  const label = (a) => a.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <div className="space-y-6 max-w-4xl" data-testid="activity-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold flex items-center gap-2"><Activity size={26} /> My Activity Log</h1>
        <p className="text-sm text-muted-foreground">All actions you have performed, most recent first</p>
      </div>
      <div className="card overflow-hidden">
        <table className="table-clean">
          <thead><tr><th>Action</th><th>Details</th><th>Timestamp</th></tr></thead>
          <tbody data-testid="activity-body">
            {logs.length === 0 && <tr><td colSpan={3} className="text-center text-muted-foreground py-8">No activity yet</td></tr>}
            {logs.map((l) => (
              <tr key={l.id}>
                <td><span className="badge badge-blue">{label(l.action)}</span></td>
                <td className="text-sm text-muted-foreground">{l.details || "—"}</td>
                <td className="text-xs text-muted-foreground">{new Date(l.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
